<template>
  <div v-if="care_vital_sign.care_has_vital_signs.length > 0">
    <p
      :class="[
        'm-0 text-thirteen upper-text',
        handleColorBloodPressure(
          item.initial_description,
          item.final_description
        ),
      ]"
    >
      {{ item.description }}
      {{ item.abbreviation }}
    </p>
    <p class="mb-1 worksansr text-twelve upper-text">
      CADASTRADO POR: {{ item.user_name }}
    </p>
    <hr />
  </div>
</template>

<script>
export default {
  name: "PressaoArterial",
  props: {
    care_vital_sign: Object,
    item: Object,
  },
  methods: {
    handleColorBloodPressure(initial, final) {
      if (parseInt(initial) >= 100 && parseInt(initial) <= 140) {
        if (parseInt(final) >= 60 && parseInt(final) <= 90) {
          return "color-green";
        }
        if (parseInt(final) >= 50 && parseInt(final) <= 59) {
          return "color-orange";
        }
      }

      if (parseInt(initial) >= 141 && parseInt(initial) <= 179) {
        if (parseInt(final) >= 91 && parseInt(final) <= 109) {
          return "color-orange";
        } else {
          return "color-red";
        }
      }

      return "color-red";
    },
  },
};
</script>